import React, { ReactElement } from 'react'
import styled from 'styled-components'

import DecimalInput from '../../../../../../../1stlog-ui/src/components/DecimalInput'
import Field, {
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import {
  composeValidators,
  mustBeNumberUpdate,
  mustBePositive,
  required,
} from '../../../../../../../1stlog-ui/src/components/Field/Validation'
import UnitSelect from './UnitSelect'

const Wrapper = styled.div`
  display: flex;
`

const Amount = (): ReactElement => {
  const limitedQuantityEnabled = useField('limitedQuantityEnabled')

  return (
    <Wrapper>
      <div className="flex-fill">
        <Field
          name="amount"
          label={i18n.t('label_amount', 'Menge')}
          validate={composeValidators(
            required,
            mustBeNumberUpdate,
            mustBePositive,
          )}
          // validateFields={["explosiveMass"]}
          required
        >
          <DecimalInput minimumFractionDigits={2} />
        </Field>
      </div>
      <div style={{ width: '150px' }}>
        <Field
          name="unit"
          label={<span>&nbsp;</span>}
          disabled={limitedQuantityEnabled}
        >
          <UnitSelect />
        </Field>
      </div>
    </Wrapper>
  )
}

export default Amount
